function loadVendorAddresses() {
    var id = $('#vendor_id').val();
    $('#vendor-addresses').html('').load('/admin/vendors/' + $('#vendor_id') + '/addresses'.val());
}


$(document).ready(function () {

    $('#vendorTabs > li > a').click(function (e) {
        e.preventDefault();
        // loadNotes('vendor');
        var name = $(this).attr('href');
        loadNotes();
        $(this).tab('show');
    });
});

